// Copyright (c) 2023, Business Centric Network and contributors
// For license information, please see license.txt

frappe.provide("bcn");

$.extend(bcn, {
	/*
	 * Utils
	 */
	absurl(href) {
		var link = document.createElement("a");
		link.href = href;
		return link.href;
	},

	navigate(url) {
		window.location.href = bcn.absurl(url);
	},

	subscribe_to_newsletter(opts, btn) {
		return frappe.call({
			type: "POST",
			method: "newsletter.newsletter.doctype.newsletter.newsletter.subscribe",
			btn: btn,
			args: {"email": opts.email},
			callback: opts.callback
		});
	}
});
